import type { DetailMainProps } from "@widgets/detail";
import { DetailMain } from "@widgets/detail";

export const NewsDetailMain = (props: DetailMainProps) => {
  return <DetailMain {...props} />;
};
